
import { mapActions, mapState, mapGetters, mapMutations } from "vuex";
import ResponsiveDialog from "./responsive-dialog.vue";
const VIEW_LIST = "list";
const VIEW_ADD_DESCRIPTION = "add-description";
export default {
  components: { ResponsiveDialog },
  props: {
    dialog: false
  },
  data() {
    return {
      currentView: VIEW_LIST,
      selectedItem: null,
      VIEW_LIST,
      VIEW_ADD_DESCRIPTION,
      descriptionRule: [
        (v) =>
          !this.selectedItem.description ||
          v.trim().toLowerCase() !==
            this.selectedItem.item_name.trim().toLowerCase() ||
          "Description cannot be same as item name",
        (v) =>
          !v ||
          v.trim().length >= 10 ||
          "Description required min 10 characters"
      ],
      valid: false
    };
  },
  computed: {
    ...mapState("menu", ["menuUploadList"]),
    ...mapGetters("menu", ["getItemsWithMandatoryButUnassignedDescriptions"])
  },
  methods: {
    ...mapMutations("menu", ["SET_MENU_UPLOAD_LIST_SINGLE_ITEM_PROP"]),
    addDescription(item) {
      this.selectedItem = { ...item };
      this.currentView = VIEW_ADD_DESCRIPTION;
    },
    handleCancel() {
      this.currentView = VIEW_LIST;
      this.selectedItem.description = null;
      this.selectedItem = null;
    },
    handleProceedWithDescription() {
      const index = this.getMenuUploadItemIndex(
        this.menuUploadList,
        this.selectedItem.id
      );

      if (index !== -1) {
        this.SET_MENU_UPLOAD_LIST_SINGLE_ITEM_PROP({
          index: index,
          propName: "description",
          propValue: this.selectedItem.description
        });
      }

      this.currentView = VIEW_LIST;
      this.selectedItem.description = null;
      this.selectedItem = null;
      this.$nextTick(() => {
        if (!this.getItemsWithMandatoryButUnassignedDescriptions.length) {
          this.$emit("close-dialog");
        }
      });
    }
  }
};
